<template>
  <div class="row">
    <div class="col-12">
      <card :title="trans.roles.show.title" :subTitle="trans.roles.show.description">
        <back-button v-if="hasPermissions('roles')" :routeName="'roles'"></back-button>
        <div class="row">
          <div class="col-md-10 offset-md-1">
            <table class="table table-striped table-bordered">

              <tbody>
                <tr v-if="role.id">
                  <th scope="col">{{trans.actions.actions}}</th>
                  <th scope="row">
                    <edit-button v-if="hasPermissions('roles_edit')" :routing="{name: 'roles.edit', params: {id: role.id}}"></edit-button>
                    <delete-button v-if="role.id != 1 && hasPermissions('roles_delete')" :deleteUrl="'/roles/' + role.id" :data="role" @deleteData="deleteData"></delete-button>
                  </th>
                </tr>

                <tr>
                  <th scope="col">{{trans.roles.fields.name}}</th>
                  <th scope="row">{{ role.name }}</th>
                </tr>
              <tr>

                <th scope="col">{{trans.roles.fields.permissions}}</th>
                <th scope="row">
                  <div class="col-md-12">
                      <div style="width:33.333333%; display: inline-block" v-for="(v, k) in permissions" :value="k" :key="k">
                      <label for="" >{{ trans[k].title }}</label>
                      <div v-for="(v2, k2) in v" :key="k2">
                          <input type="checkbox" :id="k2" :value="k2"  v-model="role.permissions" disabled> {{ trans.actions[v2] }}
                      </div>
                  </div>

                  </div>

                </th>
              </tr>
              <tr>
                <th scope="col">{{trans.roles.fields.created_at}}</th>
                <th scope="row">{{ role.created_at }}</th>
              </tr>
              <tr>
                <th scope="col">{{trans.roles.fields.last_update}}</th>
                <th scope="row">{{ role.updated_at }}</th>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import router from '@/router'
export default {
  data() {
    return {
      role: {},
      isRequested: false,
      permissions: {}
    };
  },
  created() {
    this.getPermissions();
    this.findOne();
  },
  methods: {
    findOne() {
      this.$baseApi.get('/roles/' + this.$route.params.id).then((response) => {
        if (response.data.code === 200 && response.data.data != null) {
          this.role = response.data.data;
        } else if (response.data.code === 404) {
          router.push('/roles');
        } else {
          alert(response.data.error);
          router.push('/roles');
        }
      });
    },
    getPermissions(){
        this.$baseApi.get('/roles/get/permissions').then((response)=>{
            if(response.data.code == 200){
                this.permissions = response.data.data;
            }else{
                alert(response.data.error.error);
            }
        });
      },
      deleteData(data){
         router.push('/roles');
      }
  },
  computed: {
    trans() {
      return this.$store.getters.GET_TRANS;
    }
  }
}

</script>
<style>
</style>
